/** Die Markenfarbe eines Auftritts landet als CSS-Variable auf <html>; die Stylesheets kennen nur die Variable. */
export function applyBrandColor(color: string | null): void {
  const root = document.documentElement;
  const brand = color && /^#[0-9a-f]{6}$/i.test(color) ? color : '#1f4e5f';
  root.style.setProperty('--brand', brand);
  root.style.setProperty('--brand-ink', readableOn(brand));
}

/** Weiß oder Schwarz – je nachdem, was auf der Farbe lesbar bleibt. */
function readableOn(hex: string): string {
  const channel = (i: number) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  const luminance = 0.2126 * channel(1) + 0.7152 * channel(3) + 0.0722 * channel(5);
  return luminance > 0.4 ? '#111111' : '#ffffff';
}
